import React, {Fragment, useContext, useEffect, useState, Suspense} from 'react';
import {
  BrowserRouter as Router,
  Route,
  Routes, Navigate,
} from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import {Home} from './pages/Home';
import {Inbox} from './pages/Inbox';
import {AutomationRules} from './pages/AutomationRules';
import {ThreatExceptions} from './pages/ThreatExceptions';
import {Settings} from './pages/Settings';
import {ScanSettings} from './pages/ScanSettings';
import {Authen} from './pages/Authen/Authen';
import {Logout} from './pages/Logout/Logout';
import {Callback} from './pages/Callback';
import {Header} from './components/organisms/Header';
import {Footer} from './components/organisms/Footer';
import {PageNotFound} from './pages/PageNotFound/PageNotFound';
import {LeftNavButton} from './components/molecules/LeftNavButton';
import {GlobalContext, GlobalProvider} from "./context/GlobalState"
import { createTheme, ThemeProvider } from '@mui/material/styles';
import LightTheme from "./theme/light";
import {isMobileOnly} from "react-device-detect";
import IdleTimeOutHandler from './components/utils/IdleTimeOutHandler';
import {AutomationRuleNewDetails} from "./pages/AutomationRuleNewDetails";
import {useRoleContext} from "./context/RoleContext";
import {LoadingPage} from "./components/organisms/LoadingPage";
import {BlockPage} from "./components/organisms/BlockPage";
import PrivateRoute from "./components/utils/PrivateRoute";
import DownloadToken from "./components/utils/DownloadToken";
import {setMenuRoute, GlobalMenuRoute} from "./routing/routes";
// MSAL login Azure
import {MsalProvider} from "@azure/msal-react";
import {Configuration, PublicClientApplication} from "@azure/msal-browser";
import {msalConfig} from "./api/azure";
import {BlockList} from "./pages/BlockList";
import {getTimeZoneName, handleSpinEmailDetailTabs} from "./utils/common";
import {BlockListActivityLogs} from "./pages/BlockListActivityLogs";
import {AuthenAzure} from "./pages/AuthenAzure";

import {AttachmentsReport} from "./pages/AttachmentsReport";
import {ReporterReport} from "./pages/ReporterReport";
import {SenderReport} from "./pages/SenderReport";
import {DomainUrlReport} from "./pages/DomainUrlReport";
import moment from "moment-timezone";
import EmailTemplate from "./pages/EmailTemplate/EmailTemplate";
import EmailTemplateNewDetails from './pages/EmailTemplateNewDetails/EmailTemplateNewDetails';

import { useLocation } from "react-router-dom";

const queryClient = new QueryClient();
const theme = createTheme(LightTheme);
export const msalInstance = new PublicClientApplication(msalConfig as Configuration);

const App: React.FC = () => {
  const [isOpen, setOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn')=='true')
  const [isArchivedEmail, setIsArchivedEmail] = useState(false)
  const [settingStatus, setSettingStatus] = useState()
  const [loadingPage, setLoadingPage] = useState(true)
  const { setting, setSetting } = useRoleContext()
  const [isGlobalZone, setIsGlobalZone] = useState(sessionStorage.getItem('globalZone') === "true")
  const [isShowBlockPage, setIsShowBlockPage] = useState(true)
  const currentPath = window.location.pathname
  const checkLeftNav = () => {

    setTimeout(()=>{
      window.dispatchEvent(new Event('resize'));
    },200)

    if(isOpen) {
      document?.getElementById('root')?.classList.remove('menu-opened')
    } else {
      document?.getElementById('root')?.classList.add('menu-opened')
    }

    setOpen(!isOpen);

    handleSpinEmailDetailTabs({'transitionProperty': 'width', 'transitionDuration': '0.5s'})
  }

  const onZoneChanged = () => {
    setIsGlobalZone(sessionStorage.getItem('globalZone') === "true")
  }

  const tz_name = getTimeZoneName()
  moment.tz.setDefault(tz_name);

  useEffect(() => {
    setSetting({
      ...setting
    })
  }, [settingStatus])


  const data = isGlobalZone ? GlobalMenuRoute() : setMenuRoute(setting)

  const[isActive, setIsActive]=useState(true)

  const loadingRoute = loadingPage ?
    <Route path='*' element={<LoadingPage open={true}/>}/> : null

  const redirectHomePage = <Route path='*' element={<Navigate to='/'/>}/>

  const componentWrapper = (component: React.ReactNode) =>  isGlobalZone ? <PageNotFound/> : component

  const GlobalZoneRoutes = () => (
      <Routes>
        <Route path='/callback' element={<Callback/>}/>
        <Route path='/logout' element={<Logout/>}/>
        <Route element={<PrivateRoute/>}>
          <Route path='/settings/threat-exceptions' element={<ThreatExceptions/>}/>
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
  );

  const onHeaderLoaded = () => {
    onZoneChanged()
    setIsShowBlockPage(false)
  }

  return (
    <Fragment>
      <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
          <MsalProvider instance={msalInstance}>
            <Router>
              <GlobalProvider onZoneChanged={onZoneChanged}>
                {currentPath.includes('/download/') ?
                  <Routes>
                    <Route path='/download/:token' element={<DownloadToken/>} />
                  </Routes> :
                  (
                isLoggedIn ?
                  <div>
                    <div className={'app-root'}>
                        <BlockPage open={isShowBlockPage}/>
                        <IdleTimeOutHandler onActive={()=>{setIsActive(true)}} onIdle={()=>{setIsActive(false)}}/>
                        {currentPath !== "/callback" && (
                            <>
                              <Header onClick={checkLeftNav} onComplete={onHeaderLoaded}/>

                              <div className="left-content">
                                <LeftNavButton
                                    setSettingStatus={setSettingStatus}
                                    setLoadingPage={setLoadingPage}
                                    setOpenNav={checkLeftNav}
                                    isOpen={isOpen}
                                    leftNavBtnArr={data}
                                    isArchivedEmail={isArchivedEmail}
                                />
                              </div>
                            </>
                        )}
                        <div className={isOpen ? "right-content-opened": "right-content-close"}>
                          <div className='page-content'>
                            <div className='right-content'>
                              {isGlobalZone ? (
                                  <Routes>
                                    <Route path='/callback' element={<Callback/>}/>
                                    <Route path='/logout' element={<Logout/>}/>
                                    <Route element={<PrivateRoute />}>
                                      <Route index element={<Navigate to="/settings/threat-exceptions" replace />} />

                                      <Route path="/" element={<ThreatExceptions />} />
                                      <Route path="/settings" element={<ThreatExceptions />} />
                                      <Route path="/settings/threat-exceptions" element={<ThreatExceptions />} />
                                      <Route path="/settings/scan-settings" element={<ScanSettings />} />
                                      <Route path="*" element={<Navigate to="/settings/threat-exceptions" replace />} />
                                    </Route>
                                  </Routes>
                              ) : (
                                  <Routes>
                                    <Route element={<PrivateRoute/>}>
                                      <Route path='/' element={<Home/>}/>
                                      <Route path='/dashboard' element={componentWrapper(<Home/>)}/>
                                      <Route path='/inbox' element={componentWrapper(<Inbox isOpen={isOpen} setIsArchivedEmail={setIsArchivedEmail}/>)}/>
                                      <Route path='/archived' element={componentWrapper(<Inbox isOpen={isOpen} isArchived={true} setIsArchivedEmail={setIsArchivedEmail}/>)}/>
                                      <Route path='/inbox/:id' element={componentWrapper(<Inbox isOpen={isOpen} setIsArchivedEmail={setIsArchivedEmail}/>)}/>
                                      <Route path='/archived/:id' element={componentWrapper(<Inbox isOpen={isOpen} isArchived={true} setIsArchivedEmail={setIsArchivedEmail}/>)}/>
                                      {loadingPage ? loadingRoute :
                                          !loadingPage ?
                                              <Route path='/automation-rules' element={<AutomationRules/>}/> :
                                              currentPath === '/automation-rules' ? redirectHomePage : <Route path={"*"} element={<PageNotFound/>}/>}
                                      {loadingPage ? loadingRoute :
                                          !loadingPage ?
                                              <Route path='/automation-rules/:id' element={<AutomationRuleNewDetails/>}/> :
                                              currentPath === '/automation-rules' ? redirectHomePage : <Route path={"*"} element={<PageNotFound/>}/>}
                                      {loadingPage ? loadingRoute :
                                          !loadingPage ?
                                              <Route path='/block-list' element={<BlockList/>}/> :
                                              currentPath === '/block-list' ? redirectHomePage : <Route path={"*"} element={<PageNotFound/>}/>}
                                      {loadingPage ? loadingRoute :
                                          !loadingPage ?
                                              <Route path='/block-list/activity-logs' element={<BlockListActivityLogs/>}/> :
                                              currentPath === '/block-list/activity-logs' ? redirectHomePage : <Route path={"*"} element={<PageNotFound/>}/>}
                                      {/*<Route path='/reports' element={<Reports/>}/>*/}
                                      <Route path='/reports/attachments' element={componentWrapper(<AttachmentsReport/>)}/>
                                      <Route path='/reports/reporters' element={componentWrapper(<ReporterReport/>)}/>
                                      <Route path='/reports/senders' element={componentWrapper(<SenderReport/>)}/>
                                      <Route path='/reports/domains-urls' element={componentWrapper(<DomainUrlReport/>)}/>
                                      <Route path='/settings' element={componentWrapper(<Settings/>)}/>
                                      <Route path='/settings/email-templates' element={componentWrapper(<EmailTemplate/>)}/>
                                      <Route path='/settings/email-templates/new' element={componentWrapper(<EmailTemplateNewDetails/>)}/>
                                      <Route path='/settings/email-templates/:id' element={componentWrapper(<EmailTemplateNewDetails/>)}/>
                                      <Route path='/settings/threat-exceptions' element={<ThreatExceptions/>}/>
                                      <Route path="/settings/scan-settings" element={<ScanSettings />} />
                                      <Route path='/callback' element={<Callback/>}/>
                                      <Route path='/logout' element={<Logout/>}/>
                                      <Route path={"*"} element={componentWrapper(<PageNotFound/>)}/>
                                      <Route path='/oauth/redirect' element={componentWrapper(<AuthenAzure/>)} />
                                    </Route>
                                  </Routes>
                              )}
                            </div>
                          </div>
                        </div>
                        <LoadingPage open={loadingPage}/>
                      {!isMobileOnly ? <Footer/> : <></>}
                    </div>
                  </div>: <Routes>
                    <Route path='/dashboard' element={<Logout />} />
                    <Route path='/inbox' element={<Logout />} />
                    <Route path='/inbox/:id' element={<Logout />} />
                    <Route path='/archived/:id' element={<Logout />} />
                    <Route path='/archived' element={<Logout />} />
                    <Route path='/automation-rules' element={<Logout/>} />
                    <Route path='/automation-rules/:id' element={<Logout />} />
                    <Route path='/block-list' element={<Logout />} />
                    <Route path='/block-list/activity-logs' element={<Logout />} />
                    <Route path='/reports' element={<Logout />} />
                    <Route path='/reports/attachments' element={<Logout/>}/>
                    <Route path='/reports/reporters' element={<Logout/>}/>
                    <Route path='/reports/senders' element={<Logout/>}/>
                    <Route path='/reports/domains-urls' element={<Logout/>}/>
                    <Route path='/settings' element={<Logout />} />
                    <Route path='/settings/email-templates/new' element={<Logout/>}/>
                    <Route path='/settings/email-templates/:id' element={<Logout/>}/>
                    <Route path='/settings/threat-exceptions' element={<Logout/>}/>
                    <Route path='/settings/scan-settings' element={<Logout/>}/>
                    <Route path='/logout' element={<Logout />} />
                    <Route path={"*"} element={<PageNotFound/>} />
                    <Route path='/' element={<Logout />} />
                    <Route path='/callback' element={<Callback/>} />
                    <Route path='/oauth' element={<Authen/>} />
                    <Route path='/oauth/redirect' element={<Logout/>} />
                  </Routes>
                  )}
              </GlobalProvider>
            </Router>
          </MsalProvider>
        </QueryClientProvider>
      </ThemeProvider>

    </Fragment>
  );
};

export default App;
